<template>
  <div>
    <section class="hero purple-bg text-center pb-120 pt-120">
      <h1 class="title"><router-link to="/faq">Bulletin FAQ</router-link></h1>
    </section>
    <div class="container pb-130 pb-80-md">
      <div v-show="togglePageType" class="breadcrumb"></div>
      <div class="border-bottom text-center mt-65 mb-35">
        <div @click="toggleSection(true)" class="btn px-90 pb-15" :class="{ selected: toggle }">
          <h4>retailers</h4>
        </div>
        <div @click="toggleSection(false)" class="btn px-90 pb-15" :class="{ selected: !toggle }">
          <h4>brands</h4>
        </div>
      </div>
      <div class="sections-container" v-show="!togglePageType">
        <section class="retailers">
          <div class="grid-container">
            <div v-for="(item, index) in data[toggle ? 0 : 1].sections" @click="handleClick(item.ID)" class="grid-item">
              <div>
                <img
                  v-if="item.ID === 'meet-bulletin' || item.ID === 'meet-bulletin-b'"
                  src="@/assets/img/faq/meet-bulletin.svg"
                  alt=""
                />
                <img v-if="item.ID === 'start-shopping'" src="@/assets/img/icon-cart.svg" alt="" />
                <img v-if="item.ID === 'terms-and-payments'" src="@/assets/img/icon-dollar.svg" alt="" />
                <img
                  v-if="item.ID === 'returns-and-damages' || item.ID === 'damages-b'"
                  src="@/assets/img/faq/damages.svg"
                  alt=""
                />
                <img
                  v-if="item.ID === 'order-cancellations' || item.ID === 'returns-b'"
                  src="@/assets/img/faq/returns.svg"
                  alt=""
                />
                <img v-if="item.ID === 'fulfillment-and-shipping'" src="@/assets/img/faq/shipping.svg" alt="" />
                <img v-if="item.ID === 'assortment-support'" src="@/assets/img/icon-support.svg" alt="" />
                <img v-if="item.ID === 'our-guidelines-b'" src="@/assets/img/faq/our-guidelines.svg" alt="" />
                <img v-if="item.ID === 'getting-started-b'" src="@/assets/img/faq/getting-started.svg" alt="" />
                <img v-if="item.ID === 'your-profile-b'" src="@/assets/img/faq/your-profile.svg" alt="" />
                <img v-if="item.ID === 'commission-payouts-b'" src="@/assets/img/faq/our-guidelines.svg" alt="" />
              </div>
              <div class="mr-25 line-height-1-5">
                <h4>{{ item.title }}</h4>
                {{ item.description }}
              </div>
            </div>
          </div>
        </section>
      </div>
      <div class="article-container" v-show="togglePageType">
        <div v-for="section in sections">
          <section v-if="togglePageType === section.ID">
            <aside>
              <ul>
                <li v-for="subNav in section.page">
                  <h4 class="pb-8">
                    <a :href="`#${subNav.slug}`">{{ subNav.title }}</a>
                  </h4>
                </li>
              </ul>
            </aside>
            <main>
              <div v-for="subSection in section.page" class="subSection">
                <h4 :id="subSection.slug">{{ subSection.title }}</h4>
                <p v-for="p in subSection.copy" class="mt-20">
                  <img v-if="p.image" :src="p.image" class="width-100" />
                  <span v-else v-html="p"></span>
                </p>
              </div>
            </main>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import faqJSON from "../../data/_faq.json";
import Vue from "vue";

export default {
  data() {
    return {
      data: [],
      sections: [],
      toggle: true,
      togglePageType: false,
      currentPage: null,
    };
  },

  methods: {
    toggleSection(toggle) {
      this.toggle = toggle;
      this.togglePageType = false;
      this.$router.push("/faq/");
    },
    handleClick(target) {
      this.$router.push("/faq/" + target);
    },
    hasPage() {
      return this.$router.currentRoute.params.page ? this.$router.currentRoute.params.page : false;
    },
  },
  beforeMount() {
    this.data = this.$utils.deepClone(faqJSON);
    this.sections = this.data[0].sections.concat(this.data[1].sections);
    Vue.set(this.data);
    Vue.set(this.sections);
  },
  mounted() {
    this.togglePageType = this.hasPage();
  },
  watch: {
    "$route.params.page": function () {
      this.togglePageType = this.hasPage();
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/sass/base/vars.scss";
@import "../../assets/sass/base/helpers.scss";
.grid-container {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-column-gap: 28px;
  row-gap: 28px;
  width: calc(100% - 28px);

  @include respond-to("small") {
    grid-template-columns: 100%;
    width: 100%;
  }

  .grid-item {
    transition: all 0.2s ease;

    display: grid;
    cursor: pointer;
    border: solid 1px rgba(0, 0, 0, 0.2);
    grid-template-columns: 36% 51%;
    align-items: center;
    padding-top: 40px;
    padding-bottom: 40px;
    min-height: 180px;

    &:hover {
      background-color: #fff500;
    }

    h4 {
      margin-bottom: 16px;
    }
    > div {
      text-align: center;

      img {
        @include respond-to("medium") {
          width: 50%;
        }
      }
    }
    > div:nth-child(2) {
      text-align: left;
    }
  }
}
.border-bottom {
  border-bottom: solid 1px rgba(0, 0, 0, 0.2) !important;
}

.btn {
  display: inline-block;
  padding: 20px 40px;
  margin: auto 1%;
  text-align: center;
  &:hover {
    cursor: pointer;
    border-bottom: 2px solid black;
  }
  &.selected {
    border-bottom: 2px solid black;
  }
}
.article-container {
  section {
    aside ul {
      position: sticky;
      top: 105px;
      @include respond-above("medium") {
        top: 120px;
      }
    }
    display: grid;
    grid-template-columns: 30% 70%;

    .subSection {
      h4 {
        padding-top: 95px;
        @include respond-above("medium") {
          padding-top: 120px;
        }
      }
    }
  }
}
</style>
